(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tv-product-card"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__tvCardInit) return;
    window.__tvCardInit = true;

    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

    /* ---------- Toast styles (injected once) ---------- */
    var style = document.createElement('style');
    style.textContent =
      '.tv-toast{position:fixed;top:1rem;right:1rem;z-index:2147483000;display:flex;align-items:center;gap:.9rem;' +
      'max-width:min(92vw,24rem);padding:.9rem 1.1rem;background:#fff;color:#5a1d1a;border:1px solid #b79691;' +
      'border-left:4px solid #b3262e;box-shadow:0 10px 30px rgba(0,0,0,.15);font-size:.95rem;line-height:1.35;' +
      'opacity:0;transform:translateY(-12px);transition:opacity .25s ease,transform .25s ease;pointer-events:none}' +
      '.tv-toast.is-visible{opacity:1;transform:none;pointer-events:auto}' +
      '.tv-toast--error{border-left-color:#8a0f14}' +
      '.tv-toast__text{flex:1;min-width:0}' +
      '.tv-toast__text strong{display:block;font-weight:600}' +
      '.tv-toast__text span{display:block;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;opacity:.8}' +
      '.tv-toast__link{flex:none;padding:.5rem .8rem;background:#b3262e;color:#f6e7c8;border:0;font:inherit;' +
      'font-size:.75rem;font-weight:600;letter-spacing:.1em;text-transform:uppercase;text-decoration:none;cursor:pointer}' +
      '.tv-card__button.is-loading{opacity:.7;cursor:progress}' +
      '@media (max-width:749px){.tv-toast{left:1rem;right:1rem;max-width:none}}';
    document.head.appendChild(style);

    var toastEl, toastTimer;
    function showToast(title, sub, isError) {
      if (!toastEl) {
        toastEl = document.createElement('div');
        toastEl.setAttribute('role', 'status');
        toastEl.setAttribute('aria-live', 'polite');
        document.body.appendChild(toastEl);
      }
      toastEl.className = 'tv-toast' + (isError ? ' tv-toast--error' : '');
      toastEl.innerHTML = '';

      var text = document.createElement('div');
      text.className = 'tv-toast__text';
      var strong = document.createElement('strong');
      strong.textContent = title;
      text.appendChild(strong);
      if (sub) {
        var span = document.createElement('span');
        span.textContent = sub;
        text.appendChild(span);
      }
      toastEl.appendChild(text);

      if (!isError) {
        var link = document.createElement('a');
        link.className = 'tv-toast__link';
        link.href = root + 'cart';
        link.textContent = 'View cart';
        link.addEventListener('click', function (e) {
          if (document.querySelector('cart-drawer-component, cart-drawer')) {
            e.preventDefault();
            openDrawer();
            hideToast();
          }
        });
        toastEl.appendChild(link);
      }

      requestAnimationFrame(function () {
        toastEl.classList.add('is-visible');
      });
      clearTimeout(toastTimer);
      toastTimer = setTimeout(hideToast, 4000);
    }

    function hideToast() {
      if (toastEl) toastEl.classList.remove('is-visible');
    }

    /* ---------- Quantity − / + ---------- */
    document.addEventListener('click', function (event) {
      var btn = event.target.closest('[data-tv-minus], [data-tv-plus]');
      if (!btn) return;
      var wrap = btn.closest('[data-tv-qty]');
      var input = wrap && wrap.querySelector('input[name="quantity"]');
      if (!input) return;
      var current = parseInt(input.value, 10) || 1;
      var next = btn.hasAttribute('data-tv-plus') ? current + 1 : current - 1;
      input.value = Math.max(1, next);
    });

    /* ---------- Cart count fallback (used only if theme events are unavailable) ---------- */
    function updateCountFallback(count) {
      document
        .querySelectorAll(
          '[data-cart-count], .cart-count-bubble span[aria-hidden="true"], cart-icon .cart-bubble__text-count'
        )
        .forEach(function (el) {
          el.textContent = count;
        });
    }

    /* ---------- Open the side cart drawer (several fallbacks) ---------- */
    function openDrawer() {
      var drawer = document.querySelector('cart-drawer-component');
      if (drawer) {
        try {
          if (typeof drawer.open === 'function') drawer.open();
          else if (typeof drawer.showDialog === 'function') drawer.showDialog();
        } catch (e) {}
        var dialog = drawer.querySelector('dialog');
        if (dialog && !dialog.open) {
          try { dialog.showModal(); } catch (e) {}
        }
        return;
      }
      var legacy = document.querySelector('cart-drawer');
      if (legacy && typeof legacy.open === 'function') {
        legacy.open();
        return;
      }
      var trigger = document.querySelector('cart-icon a, cart-icon button, #cart-icon-bubble');
      if (trigger) trigger.click();
    }

    /* ---------- Re-render the cart drawer (and header cart icon) from the server ---------- */
    async function refreshDrawer() {
      try {
        var drawer = document.querySelector('cart-drawer-component');
        if (!drawer) return false;
        var host = drawer.closest('.shopify-section');
        if (!host || !host.id) return false;
        var sectionId = host.id.replace(/^shopify-section-/, '');

        var res = await fetch(
          window.location.pathname + '?section_id=' + encodeURIComponent(sectionId) + '&t=' + Date.now(),
          { headers: { Accept: 'text/html' }, cache: 'no-store' }
        );
        if (!res.ok) return false;
        var doc = new DOMParser().parseFromString(await res.text(), 'text/html');

        var freshDrawer = doc.querySelector('cart-drawer-component');
        if (!freshDrawer) return false;
        var dialog = drawer.querySelector('dialog');
        var freshDialog = freshDrawer.querySelector('dialog');
        if (dialog && freshDialog) {
          // keep the existing <dialog> so the theme's cached references stay valid
          dialog.innerHTML = freshDialog.innerHTML;
        } else {
          drawer.innerHTML = freshDrawer.innerHTML;
        }
        if (typeof drawer.updatedCallback === 'function') drawer.updatedCallback();

        var freshIcon = doc.querySelector('cart-icon');
        var currentIcon = document.querySelector('cart-icon');
        if (freshIcon && currentIcon) currentIcon.innerHTML = freshIcon.innerHTML;
        return true;
      } catch (e) {
        return false;
      }
    }

    /* ---------- AJAX add to cart ---------- */
    document.addEventListener('submit', async function (event) {
      var form = event.target;
      if (!form || !form.classList || !form.classList.contains('tv-card__form')) return;
      event.preventDefault();

      var button = form.querySelector('.tv-card__button');
      if (!button || button.disabled) return;

      var originalLabel = button.textContent;
      button.disabled = true;
      button.classList.add('is-loading');
      button.textContent = 'Adding…';

      var card = form.closest('.tv-card');
      var titleEl = card && card.querySelector('.tv-card__title');
      var productTitle = titleEl ? titleEl.textContent.trim() : '';

      try {
        var formData = new FormData(form);

        // Ask Shopify to return the re-rendered cart sections so the drawer updates instantly
        var sectionIds = [];
        document.querySelectorAll('cart-items-component').forEach(function (el) {
          if (el.dataset.sectionId) sectionIds.push(el.dataset.sectionId);
        });
        var legacyDrawer = document.querySelector('cart-drawer');
        if (legacyDrawer && typeof legacyDrawer.getSectionsToRender === 'function') {
          legacyDrawer.getSectionsToRender().forEach(function (s) {
            sectionIds.push(s.id);
          });
        }
        if (sectionIds.length) {
          formData.append('sections', sectionIds.join(','));
          formData.append('sections_url', window.location.pathname);
        }

        var response = await fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: formData
        });
        var data = await response.json();

        if (!response.ok || data.status) {
          showToast('Could not add to cart', data.description || data.message || 'Please try again.', true);
          return;
        }

        var cart = await (await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })).json();

        // Let the theme refresh its drawer + cart count bubble
        var themeNotified = false;
        try {
          var events = await import('@theme/events');
          if (events && events.CartAddEvent) {
            form.dispatchEvent(
              new events.CartAddEvent({}, String(data.variant_id || data.id || ''), {
                source: 'tv-card',
                itemCount: cart.item_count,
                productId: String(data.product_id || ''),
                sections: data.sections
              })
            );
            themeNotified = true;
          }
        } catch (err) {
          /* theme events module not available – use fallbacks below */
        }

        if (!themeNotified) {
          updateCountFallback(cart.item_count);
          if (legacyDrawer && typeof legacyDrawer.renderContents === 'function') {
            legacyDrawer.renderContents(data);
          }
        }

        // Re-render the drawer from the server (fixes the "empty cart" state), then open it
        var refreshed = await refreshDrawer();
        openDrawer();

        showToast('Item added to cart', productTitle, false);
      } catch (error) {
        showToast('Something went wrong', 'Please try again.', true);
      } finally {
        button.disabled = false;
        button.classList.remove('is-loading');
        button.textContent = originalLabel;
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
